import * as React from 'react';
import YoutubePlayer from 'react-player/youtube';
import { Section } from '../Section';
import * as styles from './Videos.css';
import { IVideo } from '../../types/builder';
import { ResponsiveSlider } from '../ResponsiveSlider';
import { useIsBrowser } from '../../hooks';

interface IVideosProps {
  items: IVideo[];
  height: number;
}

const playerConfig = {
  playerVars: {
    rel: 0,
    controls: 1,
  },
};

export const Videos = React.forwardRef<HTMLDivElement, IVideosProps>(({ items, height }, ref) => {
  const [players, setPlayers] = React.useState<ReturnType<YoutubePlayer['getInternalPlayer']>[]>([]);
  const isBrowser = useIsBrowser();

  const renderedVideo = React.useMemo(() => {
    /**
     * Есть проблемы с гидратацией, приводящие к ошибкам:
     * "Uncaught Error: Hydration failed because
     * the initial UI does not match what was rendered on the server"
     *
     * Поэтому рендерим компонент только в браузере
     * https://github.com/cookpete/react-player/issues/1474#issuecomment-1179516802
     */
    return isBrowser
      ? items.map(({ url }: IVideo, index) => (
          <YoutubePlayer
            url={url}
            key={index}
            width="100%"
            height={height}
            onReady={player => /* istanbul ignore next */ {
              setPlayers(prevState => [...prevState, player.getInternalPlayer()]);
            }}
            config={playerConfig}
          />
        ))
      : [];
  }, [isBrowser, items, height]);

  const handleVideoChange = React.useCallback(() => {
    players.forEach(player => player.pauseVideo());
  }, [players]);

  return (
    <Section dataName="Videos">
      <div className={styles['container']} style={{ height }} ref={ref}>
        <ResponsiveSlider
          slides={renderedVideo}
          padding={20}
          withMargin={false}
          onNextButtonClick={handleVideoChange}
          onPrevButtonClick={handleVideoChange}
        />
      </div>
    </Section>
  );
});

Videos.displayName = 'Videos';
